<template>
    <nav class="sidebar-nav">
        <SidebarNavItem to="/cdr-test/dashboard" icon="experiment" title="CDR Test Suite" />
    </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SidebarNavItem from './SidebarNavItem.vue';

export default defineComponent({
    name: 'CdrTestSidebar',
    components: {
        SidebarNavItem
    }
});
</script>

<style lang="scss" scoped>
.sidebar-nav {
    display: flex;
    flex-direction: column;
}
</style>
